import styled from 'styled-components'

import CopyButton from 'components/molecules/CopyButton'

const Copy = styled(CopyButton)`
  z-index: 1;
`
export default Copy
